module.exports = __webpack_public_path__ + "img/mdf.f6718089.svg";